import React from 'react';
import CreateAmount, { ICreateAmountProps } from '../CreateAmount/CreateAmount';

interface IEditAmountProps extends ICreateAmountProps {}

const defaultProps: IEditAmountProps = {
  editing: true,
  visible: false,
  onOk: () => {},
  onCancel: () => {},
  onSubmit: () => {},
  vatTypes: [],
};

const EditAmount = (props: IEditAmountProps = defaultProps) => {
  return <CreateAmount {...props} />;
};

export default EditAmount;
